























import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class HomeStaticContent extends Vue {
  get appName() {
    return vxm.utility.CandidatePortalApplicationName;
  }
  get homePageStaticImage() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${
      vxm.jobs.BrandingInfo.companycode
    }/CANDIDATEPORTAL/home_static_image.png`;
  }
  get homePageStaticMessage() {
    return vxm.configs.getGlobalConfigValue('HOME_PAGE_STATIC_MSG')
  }
  get homePageStaticHeader() {
    return (
      vxm.configs.getGlobalConfigValue('HOME_PAGE_STATIC_HEADER') || 'Build a strong profile'
    );
  }
  findMyProfile() {
    this.$router.push({
      path: vxm.configs.getGlobalConfigValue('ENABLE_USER_PROFILE_V2')
        ? '/myprofile/v2/details'
        : '/myprofile/details',
    });
  }
}
